import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router";
import {
  AUTH_REDIRECT_ROUTE_PATH,
  AUTH_REDIRECT_ROUTE_PATH_RETURN_PARAM,
} from "../../constants/contants";

export function RouteCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const callback = useMemo<string>(() => {
    const returnTo = params.get(AUTH_REDIRECT_ROUTE_PATH_RETURN_PARAM);
    if (returnTo) {
      return decodeURIComponent(returnTo)
        .replace(`${window.location.origin}/${AUTH_REDIRECT_ROUTE_PATH}`, "")
        .replace(window.location.origin, "");
    }

    return window.location.origin;
  }, [params]);

  useEffect(
    function effectOnCallbackNavigate() {
      navigate(callback);
    },
    [callback, navigate],
  );

  return null;
}
